// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24 // 1 day
export const TOKEN_COOKIE = 'funifier.token'
export const REFRESH_TOKEN_COOKIE = 'funifier.refreshToken'
export const BADGES_STORAGE_KEY = 'funifier.badges'
export const VERSION = 'v1.0.0'